import React from "react";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/lib/site";
import { useContent } from "@/lib/content";
import { getIcon } from "@/lib/icons";

export default function CareerGuidance({ onConsult }) {
  const { content } = useContent();
  const g = content.career_guidance || {};
  const items = g.items || [];
  const img = g.image_url || SITE.media.teamCasual;

  return (
    <section id="guidance" data-testid="guidance-section" className="bg-[#f1f5f9] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-8 border-white">
            <img src={img} alt="Career mentoring session" className="w-full h-[460px] object-cover" />
            <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-lg">
              <p className="font-rubik text-base font-bold text-[#0f172a]">{g.image_caption_title || "Student Success Mentors"}</p>
              <p className="font-inter text-xs text-slate-600 mt-0.5">{g.image_caption_sub || "We don't sell courses. We design careers."}</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="font-inter text-sm font-semibold tracking-[0.18em] uppercase text-[#002570]">{g.eyebrow || "Career Guidance"}</p>
          <h2 className="mt-3 font-rubik text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0f172a] leading-tight text-balance">
            {g.headline_pre || "Confused parents. Confused students."} <span className="text-[#002570]">{g.headline_emphasis || "One free conversation"}</span> {g.headline_post || "changes everything."}
          </h2>

          <div className="mt-10 grid sm:grid-cols-2 gap-5">
            {items.map((it, i) => {
              const Icon = getIcon(it.icon);
              return (
                <div key={i} className="bg-white rounded-2xl p-6 border border-slate-100 hover:shadow-md transition-all">
                  <div className="w-11 h-11 rounded-xl bg-[#002570] text-white flex items-center justify-center mb-4">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-rubik text-lg font-semibold text-[#0f172a]">{it.title}</h3>
                  <p className="mt-2 font-inter text-sm text-slate-600 leading-relaxed">{it.desc}</p>
                </div>
              );
            })}
          </div>

          <button onClick={onConsult} data-testid="guidance-book-session-btn" className="mt-10 inline-flex items-center gap-2 bg-[#002570] text-white hover:bg-[#001a52] rounded-full px-7 py-4 font-inter font-medium transition-all hover:shadow-xl">
            Book Your Free Session <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
